import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Card } from '@/components/ui/card';

export function UserPaymentLoading() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          // Simulate random success/error
          setTimeout(() => {
            navigate(Math.random() > 0.2 ? '/payment/success' : '/payment/error');
          }, 500);
          return 100;
        }
        return prev + 10;
      });
    }, 300);

    return () => clearInterval(interval);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="bg-card border-border p-8 max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-primary/20 flex items-center justify-center mx-auto mb-6">
          <Loader2 className="w-10 h-10 text-primary animate-spin" />
        </div>
        
        <h1 className="text-2xl font-bold text-white mb-2">Processing Payment</h1>
        <p className="text-muted-foreground mb-6">Please wait while we process your payment...</p>

        {/* Progress bar */}
        <div className="w-full h-2 bg-secondary rounded-full overflow-hidden mb-4">
          <div 
            className="h-full bg-primary transition-all duration-300 ease-out"
            style={{ width: `${progress}%` }}
          />
        </div>

        <p className="text-sm text-muted-foreground">
          Do not close this window or refresh the page
        </p>
      </Card>
    </div>
  );
}

export default UserPaymentLoading;
